
import { Box, Divider, Stack, Grid, Typography, Tooltip, IconButton, Autocomplete, TextField, InputAdornment, useTheme, } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useState, useEffect } from "react";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

// icon
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import Close from '@mui/icons-material/Close';
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import CallAlertBar from "../../../Layout/Alertbar";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";

const AddNewProject = ({ handlecallback, editProjectID }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // Parent Roll  Alert Values
    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');

    const callback = () => { handlecallback(); }

    //-- get Project Number
    const [projectNumber, setProjectNumber] = useState([]);
    const [isProjectNumberLoaded, setIsProjectNumberLoaded] = useState(false);
    const [isProjectLeadLoaded, setIsProjectLeadLoaded] = useState(false);
    const [isProjectEditLoaded, setIsProjectEditLoaded] = useState(false);
    const [projectName, setProjectName] = useState('');
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [projectDescription, setProjectDescription] = useState('');

    // Project Lead
    const [projectLead, setProjectLead] = useState([]);
    const [selectedProjectLead, setSelectedProjectLead] = useState(null);
    const [projectLeadID, setProjectLeadID] = useState(0);
    const [selectedButton, setSelectedButton] = useState(null);

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',
        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });


    // load - project -lead
    useEffect(() => {
        if (!isProjectLeadLoaded) {

            const para = {
                p_companyid: 1,
            };

            callApi(API_ENDPOINTS.HR_GET_PROJECT_LEAD, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data?.length > 0) {
                        setProjectLead(data);
                    }
                    else {
                        setProjectLead([]);
                    }
                })
                .catch(error => {
                    CallMessage('error', error.message, 'Error');
                });
        }
    }, [isProjectLeadLoaded, editProjectID]);




    // edit project detail
    useEffect(() => {
        if (!isProjectEditLoaded) {

            if (editProjectID !== 0 || editProjectID !== undefined) {
                const para = {
                    p_companyid: 1,
                    p_projectid: editProjectID,
                };

                callApi(API_ENDPOINTS.HR_EDIT_PROJECT_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para)
                    .then(data => {
                        if (data?.length > 0) {
                            setProjectNumber(data[0].project_code);
                            setProjectName(data[0].project_name);
                            setStartDate(data[0].start_date);
                            setEndDate(data[0].finish_date);
                            setProjectDescription(data[0].description);
                            setProjectLeadID(data[0].id_project_lead);
                        }
                    })
                    .catch(error => {
                        CallMessage('error', error.message, 'Error');
                    });
            }

        }
    }, [isProjectEditLoaded, editProjectID]);


    // update selected project roll id

    useEffect(() => {
        if (editProjectID !== 0 || editProjectID !== undefined) {

            if (projectLead.length > 0 && projectLeadID !== 0) {
                let selected_value = projectLead.find((e) => e.id === projectLeadID);
                setSelectedProjectLead(selected_value);
            }
        }

    }, [projectLeadID]);



    // load Project Number

    useEffect(() => {
        if (!isProjectNumberLoaded) {

            if (editProjectID === 0 || editProjectID === undefined) {
                const para = {
                    p_companyid: 1,
                    p_modeid: 0,
                };

                callApi(API_ENDPOINTS.HR_GET_PROJECT_NUMBER, 'POST', { 'Content-Type': 'application/json' }, para)
                    .then(data => {
                        if (data?.length > 0) {
                            setProjectNumber(data[0].project_number);
                        }
                    })
                    .catch(error => {
                        CallMessage('error', error.message, 'Error');
                    });
            }

        }
    }, [isProjectNumberLoaded]);

    // Display Message

    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };

    // Insert project details

    const CRUD_Project = () => {
        let mode = editProjectID !== 0 ? 1 : 0;
        const para = {
            p_companyid: 1,
            p_project_name: projectName,
            p_start_date: startDate,
            p_finish_date: endDate,
            p_project_code: projectNumber,
            p_description: projectDescription,
            p_id_project_lead: projectLeadID,
            p_modeid: mode,
            p_id_project: editProjectID,
        }

        callApi(API_ENDPOINTS.HR_CRUD_PROJECT_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data?.length > 0) {
                    let message = mode === 0 ? 'New Project added successfully' : 'Project updated successfully';
                    CallMessage('info', message, 'Info');
                }

            })
            .catch(error => { CallMessage('error', error.message, 'Error'); });

    };


    return (<>
        <Box>
            {/* <Header title={editProjectID == 0 ? 'New Project' : 'Edit Project'} subtitle="" callback={callback} /> */}
            <Grid container justifyContent="space-between" alignItems="center" padding={0}>
                {/* Left-aligned: Edit Employee */}
                <Grid item>
                    <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                        {editProjectID === 0 ? 'New Project' : 'Edit Project'}
                    </Typography>
                </Grid>

                {/* Right-aligned: Buttons */}
                <Grid item>
                    <Grid container alignItems="center">
                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        {/* Save */}
                        <Grid item ml={1} mr={1}>
                            <Tooltip title="Add new orders">
                                <IconButton
                                    onClick={() => CRUD_Project()}
                                    sx={{ display: 'flex', alignItems: 'center' }}
                                    type="submit"
                                >
                                    <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                    <Typography variant="body2" sx={{ ml: 1 }}>  {editProjectID === 0 ? 'Save' : 'Edit'}</Typography>
                                </IconButton>
                            </Tooltip>
                        </Grid>

                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        <IconButton onClick={callback}>                           
                            <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                        </IconButton>
                        <Divider orientation="vertical" flexItem  />
                    </Grid>
                </Grid>
            </Grid>
            <Divider />

            {/* Message box detail */}
            <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />

            {/* Adjust screen size based on moniter */}
            <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>
                <Grid container  >
                    <Grid item xs={12} sm={12} md={12} lg={8} xl={6} mt={2}>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Project Code
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={5} xl={5}>
                                    <TextField value={projectNumber} fullWidth size="small" label="" required variant="outlined"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    <CustomTooltip
                                                        title={
                                                            <span>
                                                                <b>click here to enable or disable auto generation of employee number.</b> <br />
                                                            </span>}
                                                    >
                                                        <SettingsIcon style={{ fontSize: "20px" }} />
                                                    </CustomTooltip>

                                                </InputAdornment>
                                            ),
                                        }} />
                                </Grid>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Project Name
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={5} xl={5}>
                                    <TextField value={projectName} onChange={(e) => { setProjectName(e.target.value) }} fullWidth size="small" label="" required variant="outlined" />
                                </Grid>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Start Date
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2}>
                                            <DatePicker
                                                size="small"
                                                id="Orderdate"
                                                value={dayjs(startDate)}
                                                onChange={(date) => setStartDate(date)}
                                                slotProps={{ textField: { size: 'small' } }}
                                                fullWidth
                                                format="DD-MMM-YYYY"
                                                className="customDatePicker"
                                                renderInput={(props) => (
                                                    <TextField required {...props} />
                                                )}
                                            />
                                        </Stack>
                                    </LocalizationProvider>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        End Date
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2}>
                                            <DatePicker
                                                size="small"
                                                id="Orderdate"
                                                value={dayjs(endDate)}
                                                onChange={(date) => setEndDate(date)}
                                                slotProps={{ textField: { size: 'small' } }}
                                                fullWidth
                                                format="DD-MMM-YYYY"
                                                className="customDatePicker"
                                                renderInput={(props) => (
                                                    <TextField required {...props} />
                                                )}
                                            />
                                        </Stack>
                                    </LocalizationProvider>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Project Lead
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={5} lg={5} xl={5}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        value={selectedProjectLead}
                                        onChange={(event, newValue) => { setSelectedProjectLead(newValue); setProjectLeadID(newValue.id); }}
                                        options={projectLead}
                                        getOptionLabel={(option) => option.project_lead_name || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Project Description
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={8} xl={8}>
                                    <TextField value={projectDescription} multiline onChange={(e) => { setProjectDescription(e.target.value) }} fullWidth label="" required variant="outlined" />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>                  

                </Grid>
            </ResponsiveBox>

        </Box>

    </>)
}
export default AddNewProject;